var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVepikug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265625,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#010304"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6358 4.11465H14.8931V6.96088C13.374 7.19138 11.9297 7.80238 10.699 8.7467C9.1023 9.97189 7.95449 11.6897 7.43359 13.6337L10.0829 14.3436C10.4475 12.9828 11.251 11.7803 12.3687 10.9227C13.4864 10.0651 14.8558 9.60019 16.2646 9.60019C17.6735 9.60019 19.0429 10.0651 20.1606 10.9227C21.2783 11.7803 22.0817 12.9828 22.4464 14.3436L25.0957 13.6337C24.5748 11.6897 23.427 9.97189 21.8303 8.7467C20.5995 7.8023 19.155 7.19127 17.6358 6.96082V4.11465Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.699 23.2425C9.10233 22.0174 7.95453 20.2995 7.43363 18.3555L10.0829 17.6456C10.4476 19.0065 11.251 20.2089 12.3687 21.0666C13.4864 21.9242 14.8559 22.3891 16.2647 22.3891C17.6735 22.3891 19.0429 21.9242 20.1606 21.0666C21.2783 20.2089 22.0818 19.0065 22.4464 17.6457L25.0957 18.3555C24.5748 20.2995 23.427 22.0174 21.8303 23.2426C20.5995 24.187 19.155 24.798 17.6358 25.0284V27.8853H14.8931V25.0284C13.374 24.7979 11.9297 24.1869 10.699 23.2425Z",
    fill: "#FFD600"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7656,
    y: 10.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#FFD600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2855 14.2907C16.9957 14.4542 16.7727 14.6772 16.6092 14.9744C16.4458 15.2717 16.3714 15.6136 16.3714 16.0074C16.3714 16.4013 16.4532 16.7432 16.6167 17.0404C16.7802 17.3377 17.018 17.5606 17.3301 17.7167C17.6422 17.8802 18.0064 17.9545 18.4374 17.9545C18.7644 17.9545 19.0543 17.9025 19.3069 17.7836C19.5596 17.6647 19.7603 17.5086 19.9163 17.3005C20.065 17.0999 20.1616 16.8695 20.2062 16.6168H19.1732C19.1286 16.7952 19.032 16.9364 18.8908 17.0256C18.7496 17.1147 18.5712 17.1593 18.3631 17.1593C18.0956 17.1593 17.8801 17.085 17.7314 16.9215C17.5754 16.7655 17.4862 16.5499 17.4639 16.2675V16.2378H20.2359C20.2508 16.1338 20.2656 16.0149 20.2656 15.8811C20.2582 15.5095 20.169 15.1899 20.0055 14.915C19.842 14.64 19.6116 14.4245 19.3144 14.2759C19.0171 14.1272 18.6827 14.0455 18.2962 14.0455C17.9098 14.0455 17.5754 14.1272 17.2855 14.2907ZM18.9279 15.019C19.084 15.1454 19.1806 15.3237 19.2178 15.5541H17.4862C17.5159 15.3311 17.6051 15.1602 17.7612 15.0265C17.9172 14.8927 18.1104 14.8258 18.3408 14.8258C18.5786 14.8258 18.7719 14.8927 18.9279 15.019Z",
    fill: "#010304"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3878 14.0901H12.2656L13.6405 17.9099H14.941L16.3159 14.0901H15.216L14.3093 16.8398L13.3878 14.0901Z",
    fill: "#010304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVepikug);
export default __webpack_public_path__ + "static/media/vepikug.3472fed742c82ff55f1c06e854209d8c.svg";
export { ForwardRef as ReactComponent };